export default __webpack_public_path__ + "static/media/9@2x.a249adb9.png";